export default __webpack_public_path__ + "5f62151ccba7d1ddbf6b2b3d7e27e954.png";